<template>
	<div class="cart">
		<div class="wrap container1">
			<div class="header">
				<div class="title">
					Gennemgå ordre og accepter handelsbetingelser
				</div>
			</div>
			<orderlist v-bind="{data, products}" type="cart"/>
		</div>
		<panel v-bind="data"/>
	</div>
</template>

<script>
import orderlist from "@/components/orderlist/index.vue";
import panel from "./panel.vue";

export default {
	components: {orderlist, panel},
	computed: {
		data: (t) => t.$store.getters["cart/data"],
		products: (t) => t.$store.getters["cart/products"]
	}
};
</script>

<style lang="scss" scoped>
.cart {
	.wrap {
		.header {
			.title {
				font-family: $fontMinion;
				font-size: 28px;
				font-weight: 700;
				width: 417px;
				line-height: 36px;

				@include res(xsmall) {
					font-size: 21px;
				}
			}
		}
	}
}
</style>
